import { gql } from 'apollo-boost';

export const COURSE_LAUNCH_TRACKING_MUTATION = gql`
    mutation trackCourseLaunch($token: String!, $courseName: String!) {
        trackCourseLaunch(token: $token, courseName: $courseName) {
            success
        }
    }
`;
